import React, { useState } from 'react'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Box
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CreateCard from '../../../../Kanban/CreateCard';
import KanbanCard from '../../../../../../../components/Kanban/KanbanCard';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';

function MobileSubtask({
  filteredProjects,
  workflowId,
  id,
  milestone,
  boardName,
  parentCardId,
  boardKey
}) {
  const [isCreateCardFieldOpen, setIsCreateCardFieldOpen] = useState(false);

  const handleCreateCardClick = (event) => {
    // event?.stopPropagation();
    setIsCreateCardFieldOpen((prev) => !prev);
  };
  return (
    <>
      <Accordion className="mobile-sidebar-accordion subtask-mobile-accordion">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel-content"
          id="panel-header"
          className="mobile-accordion-header"
        >
          <Grid item className="sidebar-worklog">
            <div className="d-flex align-items-center ">
              <div className={`sidebar-worklog-detail uppercase`}>
                Sub Tasks
              </div>{" "}
              <span className="coloumn-header-length">
                {filteredProjects.length}
              </span>
            </div>
            <div className="sidebar-Addworklog-btn">
              {!isCreateCardFieldOpen && (
                <Box className="mobile-create-card-btn">
                  <AddIcon
                    onClick={(event) =>
                      handleCreateCardClick(event, "todo-column")
                    }
                  />
                </Box>
              )}
            </div>
          </Grid>
        </AccordionSummary>
        <AccordionDetails sx={{border: "none !important"}}>
          <DragDropContext>
            <Droppable droppableId={workflowId}>
              {(provided) => (
                <div
                  className="mobile-kanban-column"
                  style={{
                    maxHeight: `calc(94vh - ${milestone ? "340px" : "270px"})`,
                    overflowY: "auto",
                  }}
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                >
                  <CreateCard
                    stage={workflowId}
                    boardId={id}
                    handleCreateCardClick={handleCreateCardClick}
                    isCreateCardFieldOpen={isCreateCardFieldOpen}
                    parentCardId={parentCardId}
                  />
                  {filteredProjects.map((project, index) => (
                    <KanbanCard
                      key={`${project?.card?.card_id}`}
                      id={project?.card?.card_id}
                      project={project}
                      boardName={boardName}
                      index={index}
                      stage={workflowId}
                      boardKey={boardKey}
                    />
                  ))}
                  {filteredProjects.length === 0 && (
                    <div className="mobile-kanban-column-empty">
                      <Typography>No subtasks found</Typography>
                    </div>
                  )}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </AccordionDetails>
      </Accordion>
    </>
  );
}

export default MobileSubtask